import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	DoCheck,
	AfterViewInit
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';
import { STRING } from '../../types';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { isNullOrUndefined } from 'util';


@Component({
	selector: 'app-select',
	templateUrl: './select.component.html',
	styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit, OnChanges, DoCheck, AfterViewInit {
	labelClass: any;
	inputClass: any = [];
	asyncLoaded: boolean;
	tempValue: any;
	rowClass: any;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	@Input() formElement: any = {};
	@Input() options: any[] = [];
	@Input() label = STRING.EMPTY;
	@Input() required = false;
	@Input() name = STRING.EMPTY;
	@Input() formValue?: FormGroup;
	@Input() value: any = STRING.EMPTY;
	@Input() disabled = false;
	@Input() asyncLoad = false;
	@Output() valueChange = new EventEmitter();
	selectClass: string[] = [
		FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default
	];
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	@Output()
	blur = new EventEmitter<{
		name: string;
		value: any;
	}>();
	constructor(
		private scriptLoaderService: ScriptLoaderService
	) {}
	ngOnChanges(changes) {
		const value = changes && changes.value;
		// if (value) {
		// 	this.onChange(value.currentValue, false);
		// }
		// if (value) {
		// 	if (typeof value.currentValue === STRING.OBJECT && typeof value.previousValue === STRING.OBJECT) {
		// 		if (Helpers.compareObj(value.currentValue, value.previousValue)) {
		// 			const currentValue = this.options.find(option => option.value === value.currentValue);
		// 			const previousValue = this.options.find(option => option.value === value.previousValue);
		// 			const finalValue = previousValue && previousValue.value ||  currentValue && currentValue.value;
		// 			this.inputValue = finalValue;
		// 			// // if (!currentValue) {
		// 			// setTimeout((() => {
		// 			// 	this.value = previousValue && previousValue.value ||  currentValue && currentValue.value;
		// 			// }));
		// 			// // }
		// 		}
		// 	}
		// }
	}
	ngDoCheck() {
		this.value = this.isValidValue(this.value) ? this.value : STRING.EMPTY;
		if (this.asyncLoad) {
			if (!this.asyncLoaded && (this.value || this.tempValue)) {
				if (!this.tempValue) {
					this.tempValue = this.value;
				}
				if (this.options.length) {
					// const selectedOption = this.options.find(option => {
					// 	if (typeof option.value === STRING.OBJECT) {
					// 		return Helpers.compareObj(this.tempValue, option.value);
					// 	}
					// 	return option.value === this.tempValue;
					// });
					// this.value = selectedOption && selectedOption.value;
					this.value = this.tempValue;
					this.tempValue = STRING.EMPTY;
					this.onChange(this.value,  false);
					this.asyncLoaded = true;
				}
			}
		}
		if (!this.options.length && this.value !== STRING.EMPTY) {
			this.onChange(STRING.EMPTY);
		}
	}
	private specificView() {
		if (this.formElement.multi) {
			this.selectClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.multiple
			);
		}
	}

	private _formatView() {
		this.specificView();
		this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
		const labelDiv = this.formElement.labelDiv;
		const inputDiv = this.formElement.inputDiv;
		let derivedLabelClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
		];
		let derivedInputClass = [
			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
		];
		if (this.formElement.row) {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
			];
			derivedLabelClass.push(
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
			);
		} else {
			this.rowClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.flexRow
			];
			derivedInputClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
			derivedLabelClass = [
				FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
			];
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);
	}

	// private _formatView() {
	// 	this.selectClass.push('form-control m-input');
	// 	if (this.formElement.multi) {
	// 		this.selectClass.push('multiple');
	// 	}
	// 	if (this.formElement && Object.keys(this.formElement).length >= 0) {
	// 		this.labelClass = ['col-form-label field-label'];
	// 		this.inputClass = [];
	// 		let derivedLabelClass = [];
	// 		let derivedInputClass = [];
	// 		if (this.formElement.align && this.formElement.align === 6) {
	// 			derivedLabelClass.push('col-4');
	// 			derivedInputClass.push('col-8');
	// 		} else {
	// 			derivedLabelClass.push('col-2');
	// 			derivedInputClass.push('col-10');
	// 		}
	// 		const labelDiv = this.formElement.labelDiv;
	// 		const inputDiv = this.formElement.inputDiv;
	// 		derivedLabelClass = [`col-${labelDiv}`];
	// 		derivedInputClass = [`col-${inputDiv}`];
	// 		if (this.formElement.row) {
	// 			this.rowClass = ['row'];
	// 			derivedLabelClass.push('right-text');
	// 		} else {
	// 			derivedInputClass = ['col-12'];
	// 			derivedLabelClass = ['col-12'];
	// 		}
	// 		this.labelClass = this.labelClass.concat(derivedLabelClass);
	// 		this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	}
	// }

	ngOnInit() {
		// if (this.formElement.name === "numberOfMaleWashRooms") {
		// 	console.log("inside text")
		// 	console.log(this.formElement);
		// }
		if (this.formValue) {
			this.formElement.value = this.isValidValue(this.formValue.value) ? this.formValue.value : this.formElement.value;
			this.formValue.valueChanges.subscribe(val => {
				this.onFormValueChange(val);
			});
		}
		this._formatView();
		this.asyncLoad = this.formElement.asyncLoad;
		this.options = this.formatOptions(this.formElement.options);
		this.disabled = this.formElement.disabled || false;
		this.value = this.isValidValue(this.formElement.value) ? this.formElement.value : STRING.EMPTY;
		// this.value = this.isValidValue(this.formElement.value) ? this.formElement.value : STRING.EMPTY;
		if (!this.isEmptyString(this.value) && this.isValidValue(this.value)) {
			this.onChange(this.value);
		}
		return;
	}

	private isEmptyString(value) {
		return value === STRING.EMPTY
	}

	private isValidValue(value) {
		// return value || typeof value === STRING.BOOLEAN;
		return value || typeof value === STRING.BOOLEAN || !isNullOrUndefined(value);
	}

	ngAfterViewInit() {
		this.scriptLoaderService.addScriptTagToElementDOM(
			FORM_STYLE_CONFIG.datePicker[FORM_STYLE_CONFIG.select.default]
		);
	}

	compareFn(c1, c2): boolean {
		if (typeof c1 === STRING.OBJECT) {
			return Helpers.compareObj(c1, c2);
		}
		return c1 === c2;
	}

	onFormValueChange(val) {
		const tempVal = val;
		if (!isNullOrUndefined(val) && typeof val === STRING.OBJECT && !this.formElement.multi) {
			val = this.options.find(option => {
				return Helpers.compareObj(val, option.value);
			});
			val = val && val.value;
		}
		if (!(this.value === val)) {
			this.value = val;
			if (!this.options || !this.options.length || this.options.indexOf(val) === -1) {
				this.asyncLoad = true;
				this.asyncLoaded = false;
			}
			this.onChange(val);
			this.formValue.markAsPristine();
		}
		if (this.formElement.markAsUntouched) {
			this.formValue.markAsPristine();
			this.formValue.markAsUntouched();
			this.formElement.markAsUntouched = false;
		}
	}

	formatOptions(options) {
		options.forEach((option, index) => {
			options[index] = this._optionValue(option);
		});
		return options;
	}

	private _optionValue(option) {
		if (!(option instanceof Object)) {
			option = { name: option, value: option };
			return option;
		}
		if (option instanceof Object && option.hasOwnProperty('value')) {
			return option;
		}
		if (option.hasOwnProperty('name')) {
			option = {
				name: option.name,
				value: option.value
			};
			return option;
		}
	}
	onChange(newValue, makeDirty= true) {
		if ( newValue === null ) {
			return;
		}
		if (makeDirty) {
			this.makeDirty();
		}
		this.inputValue = newValue;
		this.valueChange.emit(newValue);
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
	}

	set inputValue(value) {
		if (this.formValue) {
			this.formValue.setValue(value);
		}
	}
	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}
	isDisabled() {
		return (this.disabled || this.formElement.readOnly) ? STRING.EMPTY : null;
	}

	get placeholder(){
		const placeholder = this.formElement.readOnly ? STRING.EMPTY : (this.formElement.placeholder);
		return placeholder;
	}
}
